<div class="flex flex-col items-center gap-4">
  <p class="font-medium">
    Votre parcours Open Banking s'est terminé sans erreur.
  </p>
  <div>
    <p class="mb-2">Open Banking case construit par l'OpenBanking:</p>
    <pre>{{ code | json }}</pre>
  </div>
</div>
